module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlak1.0554e514.jpg";